import React from 'react';

import { CalendarDate } from '~/src/common/components/CalendarDate/CalendarDate';
import { getProductUseByCalendarDate } from '~/src/common/components/CalendarDate/utils';
import I18n from '~/src/common/services/I18n';
import { ProductDetailed } from '~/src/common/typings/product';
import { getCustomTag, getProductLabelImages } from '~/src/common/utils/product';
import { ProductLabels } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/components/ProductSecondaryInformation/ProductLabels';
import MyProductsFocusButton from '~/src/screens/MyProducts/components/Buttons/MyProductsFocusButton';
import { useMyProductsButton } from '~/src/screens/MyProducts/hooks/useMyProductsButton';

import * as S from './layout';

interface Props {
  className?: string;
  product: ProductDetailed;
}

export const ProductSecondaryInformation = (props: Props) => {
  const labels = getProductLabelImages(props.product);
  const customTag = getCustomTag(props.product);
  const myProductTag = useMyProductsButton(props.product);

  const hasTag = customTag != null || myProductTag != null;

  if (
    !hasTag &&
    props.product.origin == null &&
    labels.length === 0 &&
    props.product.consumptionDate == null
  )
    return null;

  return (
    <S.Root className={props.className}>
      {hasTag ? (
        <S.Tags>
          {myProductTag ? <MyProductsFocusButton {...myProductTag} /> : null}
          {customTag ? <S.CustomTag>{customTag}</S.CustomTag> : null}
        </S.Tags>
      ) : null}

      <S.Content>
        {props.product.origin != null ? (
          <S.Item>
            <S.Label>{I18n.t('view-product-screen.origin')}</S.Label>
            <S.Flag defaultToText origin={props.product.origin} />
          </S.Item>
        ) : null}

        {labels.length > 0 ? (
          <S.Item>
            <S.Label>{I18n.t('view-product-screen.labels-title')}</S.Label>
            <ProductLabels labels={labels} />
          </S.Item>
        ) : null}

        {props.product.consumptionDate != null ? (
          <S.Item>
            <S.Label>{I18n.t('view-product-screen.use-by')}</S.Label>
            <CalendarDate {...getProductUseByCalendarDate(props.product.consumptionDate)} />
          </S.Item>
        ) : null}
      </S.Content>
    </S.Root>
  );
};
